module.exports = __webpack_public_path__ + "img/banner0.edc962b6.png";